export default function generateAnimationName(id) {
  return "k" + id;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela/es/generateAnimationName.js
// module id = 1133
// module chunks = 0